// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ICipChallengeAnswerRequestDto
 */
export interface ICipChallengeAnswerRequestDto {
    /**
     * 
     * @type {string}
     * @memberof ICipChallengeAnswerRequestDto
     */
    question1_type: string;
    /**
     * 
     * @type {string}
     * @memberof ICipChallengeAnswerRequestDto
     */
    question1_answer: string;
}

/**
 * Check if a given object implements the ICipChallengeAnswerRequestDto interface.
 */
export function instanceOfICipChallengeAnswerRequestDto(value: object): value is ICipChallengeAnswerRequestDto {
    if (!('question1_type' in value) || value['question1_type'] === undefined) return false;
    if (!('question1_answer' in value) || value['question1_answer'] === undefined) return false;
    return true;
}

export function ICipChallengeAnswerRequestDtoFromJSON(json: any): ICipChallengeAnswerRequestDto {
    return ICipChallengeAnswerRequestDtoFromJSONTyped(json, false);
}

export function ICipChallengeAnswerRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICipChallengeAnswerRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'question1_type': json['question1_type'],
        'question1_answer': json['question1_answer'],
    };
}

export function ICipChallengeAnswerRequestDtoToJSON(json: any): ICipChallengeAnswerRequestDto {
    return ICipChallengeAnswerRequestDtoToJSONTyped(json, false);
}

export function ICipChallengeAnswerRequestDtoToJSONTyped(value?: ICipChallengeAnswerRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'question1_type': value['question1_type'],
        'question1_answer': value['question1_answer'],
    };
}

